// extracted by mini-css-extract-plugin
export default {"tripRowMinimalistic":"TripAndTravelCell_tripRowMinimalistic__OjWYi"};